import React from 'react'
import { useGlobalContext } from '../context'

const SearchForm = () => {
  const { setsearchTerm } = useGlobalContext()
  const searchValue = React.useRef('')
  React.useEffect(() => {
    searchValue.current.focus()
  })

  const searchCocktail = () => {
    setsearchTerm(searchValue.current.value)
  }
  const handleSubmit = (e) => {
    e.preventDefault()
  }
  return (
    <section className='section search'>
      <form action='' className='search-form' onSubmit={handleSubmit}>
        <div className='form-control'>
          <label htmlFor='name'>Search your favortie Cocktail</label>
          <input
            type='text'
            id='name'
            ref={searchValue}
            onChange={searchCocktail}
          />
        </div>
      </form>
    </section>
  )
}

export default SearchForm
